import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { H6 } from "src/lib/components/salify-next-layout/default/components/Typography"; // DUMMY CUSTOM DATA
import CartLocationControls from "../../cart-location-controls";

// ==============================================================
const ShippingForm = (props: {
  values: any;
  errors: any;
  touched: any;
  handleBlur: any;
  handleChange: any;
  setFieldValue: any;
  controlOnly?: boolean;
  controlPrefix?: string;
  readOnly?: boolean;
}) => {
  const renderControls = () => {
    const controlPrefix = props.controlPrefix ?? "shipping";
    return (
      <Box className={"grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-14"}>
        <SalifyFallback.Label
          path="Full Name"
          default="Họ và tên"
          render={(label) => (
            <TextField
              className="col-span-2 lg:col-span-1"
              label={label}
              onBlur={props.handleBlur}
              name={`${controlPrefix}_fullName`}
              onChange={props.handleChange}
              InputProps={{ readOnly: props.readOnly }}
              value={props.values[`${controlPrefix}_fullName`]}
              error={
                !!props.touched[`${controlPrefix}_fullName`] &&
                !!props.errors[`${controlPrefix}_fullName`]
              }
              helperText={
                props.touched[`${controlPrefix}_fullName`] &&
                props.errors[`${controlPrefix}_fullName`]
              }
            />
          )}
        />

        <SalifyFallback.Label
          path="Phone Number"
          default="Số điện thoại"
          render={(label) => (
            <TextField
              className="col-span-2 lg:col-span-1"
              fullWidth
              onBlur={props.handleBlur}
              label={label}
              onChange={props.handleChange}
              name={`${controlPrefix}_phone`}
              InputProps={{ readOnly: props.readOnly }}
              value={props.values[`${controlPrefix}_phone`]}
              error={
                !!props.touched[`${controlPrefix}_phone`] &&
                !!props.errors[`${controlPrefix}_phone`]
              }
              helperText={
                props.touched[`${controlPrefix}_phone`] && props.errors[`${controlPrefix}_phone`]
              }
            />
          )}
        />

        <SalifyFallback.Label
          path="Email"
          default="Địa chỉ Email"
          render={(label) => (
            <TextField
              className="col-span-2 lg:col-span-1"
              fullWidth
              type="email"
              onBlur={props.handleBlur}
              name={`${controlPrefix}_email`}
              label={label}
              onChange={props.handleChange}
              InputProps={{ readOnly: props.readOnly }}
              value={props.values[`${controlPrefix}_email`]}
              error={
                !!props.touched[`${controlPrefix}_email`] &&
                !!props.errors[`${controlPrefix}_email`]
              }
              helperText={
                props.touched[`${controlPrefix}_email`] && props.errors[`${controlPrefix}_email`]
              }
            />
          )}
        />

        <CartLocationControls form {...props} controlPrefix={controlPrefix} />

        <SalifyFallback.Label
          path="Address"
          default="Địa chỉ"
          render={(label) => (
            <TextField
              className="col-span-2"
              fullWidth
              label={label}
              onBlur={props.handleBlur}
              onChange={props.handleChange}
              name={`${controlPrefix}_address`}
              InputProps={{ readOnly: props.readOnly }}
              value={props.values[`${controlPrefix}_address`]}
              error={
                !!props.touched[`${controlPrefix}_address`] &&
                !!props.errors[`${controlPrefix}_address`]
              }
              helperText={
                props.touched[`${controlPrefix}_address`] &&
                props.errors[`${controlPrefix}_address`]
              }
            />
          )}
        />
      </Box>
    );
  };

  if (props.controlOnly) return renderControls();

  return (
    <Card sx={{ mb: 4, p: 3 }}>
      <H6 mb={2}>
        <SalifyFallback.Label path="Shipping Address" default="Địa chỉ nhận hàng" />
      </H6>

      {renderControls()}
    </Card>
  );
};

export default ShippingForm;
